import { render, staticRenderFns } from "./TouchpointInfo.vue?vue&type=template&id=307a5f29&"
import script from "./TouchpointInfo.vue?vue&type=script&lang=js&"
export * from "./TouchpointInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("n:\\Projects\\Werk\\MarketingDbNEW\\MarketingDb.Web.Zeiss\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('307a5f29')) {
      api.createRecord('307a5f29', component.options)
    } else {
      api.reload('307a5f29', component.options)
    }
    module.hot.accept("./TouchpointInfo.vue?vue&type=template&id=307a5f29&", function () {
      api.rerender('307a5f29', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "ScriptsV2/Core/Modules/JourneyBuilder/Components/Composer/TouchpointOverview/TouchpointInfo.vue"
export default component.exports